
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as giftcodeZ05LN6FmmLMeta } from "/app/src/pages/giftcode.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as paymentCOFIH6inNyMeta } from "/app/src/pages/payment.vue?macro=true";
import { default as storeoGRkVjIBlFMeta } from "/app/src/pages/store.vue?macro=true";
import { default as userinfonleQSz5fxXMeta } from "/app/src/pages/userinfo.vue?macro=true";
import { default as godSDrvXSxmI0Meta } from "/app/src/pages/wap/god.vue?macro=true";
export default [
  {
    name: "giftcode",
    path: "/giftcode",
    component: () => import("/app/src/pages/giftcode.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/app/src/pages/payment.vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/app/src/pages/store.vue")
  },
  {
    name: "userinfo",
    path: "/userinfo",
    component: () => import("/app/src/pages/userinfo.vue")
  },
  {
    name: "wap-god",
    path: "/wap/god",
    component: () => import("/app/src/pages/wap/god.vue")
  }
]